import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

/** Business parameter editable without a deployment (e.g. PassportExpirationYears). */
export interface SystemParameter {
    key: string;
    value: string;
    description: string;
    updatedAt: string;
    updatedBy?: string | null;
}

@Injectable({
    providedIn: 'root',
})
export class ParametersService {
    private http = inject(HttpClient);
    private controller = `system-parameters`;

    getAll() {
        return this.http.get<SystemParameter[]>(this.controller);
    }

    update(key: string, value: string) {
        return this.http.put<SystemParameter>(`${this.controller}/${encodeURIComponent(key)}`, { value });
    }
}
